import { languageMenuStyles as styles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.languageIcon = {
    ...styles.languageIcon,
    color: colorStrings.commonGlobalGray02,
};

styles.languageSelect = {
    ...styles.languageSelect,
    backgroundColor: "transparent",
    border: undefined,
    mergeCss: true,
    iconProps: {
        color: colorStrings.commonGlobalGray02,
    },
    cssOverrides: {
        inputSelect: css`
            color: ${getColor(colorStrings.commonGlobalGray02)};
            border-color: transparent;
        `,
    },
};
